import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '../ui/alert-dialog';

const ConfirmationModal = (props) => {
  const {
    isOpen,
    onClose,
    onAction,
    primaryButtonText,
    secondaryButtonText = 'Cancel',
    modalText,
    isClosable = true,
    headerText
  } = props;

  const handleOpenChange = (open) => {
    if (!open && !isClosable) {
      return;
    }
    if (!open && isClosable && onClose) {
      onClose();
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={handleOpenChange}>
      <AlertDialogContent
        onEscapeKeyDown={(event) => {
          if (!isClosable) event.preventDefault();
        }}
      >
        {headerText && (
          <AlertDialogHeader>
            <AlertDialogTitle>{headerText}</AlertDialogTitle>
          </AlertDialogHeader>
        )}
        {typeof modalText === 'string' ? (
          <AlertDialogDescription>{modalText}</AlertDialogDescription>
        ) : (
          <div className="text-sm text-muted-foreground">{modalText}</div>
        )}
        <AlertDialogFooter>
          {isClosable && (
            <AlertDialogCancel onClick={onClose}>{secondaryButtonText}</AlertDialogCancel>
          )}
          <AlertDialogAction onClick={onAction}>{primaryButtonText}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export { ConfirmationModal };
